export default "__VITE_ASSET__31695ca2__"